const storeChangeTracker = {
    namespaced: true,
    state: {
          changesPending: false,
          changeData: null
    },
    mutations: {
        changeMade(state, data) {
            state.changesPending = true;
            state.changeData = data;
        },
        clear(state) {
            state.changesPending = false;
            state.changeData = null
        },
    }
  };
  
  export default storeChangeTracker;  


// WEBPACK FOOTER //
// ./src/framework/utils/x-change-tracker.js